export default "__VITE_ASSET__D$UV0eao__"